import { makeStyles } from '@material-ui/core/styles';

import { MarkdownContent } from '../MarkdownContent';

const useStyles = makeStyles({
  root: {
    padding: 'var(--bui-space-2) 0',
    minWidth: 0,
  },
});

export const AssistantMessage = ({ content }: { content: string }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MarkdownContent>{content}</MarkdownContent>
    </div>
  );
};
